import { createApp } from 'vue';
import { Router } from 'vue-router';
import Antd from 'ant-design-vue';
import 'virtual:svg-icons-register';
import 'ant-design-vue/dist/reset.css';
import '@src/styles/index.css';
import App from '@src/App.vue';
import i18n from '@src/i18n';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import isToday from 'dayjs/plugin/isToday';

dayjs.locale('zh-cn');
dayjs.extend(isToday);

export const app = createApp(App);

export default function mountApp(options: { rootContainer?: string | Element; router: Router }) {
	app.use(Antd);
	app.use(i18n);
	app.use(options.router);
	app.mount(options.rootContainer || '#app');
}
